// client/src/components/dashboard/LearningModes.tsx
import React, { useState } from "react";
import "../../assets/styles/dashboard.css";

const learningModes = [
  { id: "visual", name: "Visual Learning" },
  { id: "auditory", name: "Auditory Learning" },
  { id: "kinesthetic", name: "Kinesthetic Learning" },
  { id: "adaptive", name: "Adaptive Learning" },
];

const LearningModes: React.FC = () => {
  const [selectedMode, setSelectedMode] = useState<string>("");

  return (
    <div className="learning-modes">
      <h2>Learning Modes</h2>
      <p>Select your preferred learning mode:</p>
      <div className="learning-modes-list">
        {learningModes.map((mode) => (
          <div
            key={mode.id}
            className={`learning-mode-item ${selectedMode === mode.id ? "selected" : ""}`}
            onClick={() => setSelectedMode(mode.id)}
          >
            {mode.name}
          </div>
        ))}
      </div>
      {selectedMode && (
        <div className="mode-description">
          <p>
            You have selected: <strong>{learningModes.find((m) => m.id === selectedMode)?.name}</strong>
          </p>
          {/* Future: Add detailed recommendations or descriptions */}
        </div>
      )}
    </div>
  );
};

export default LearningModes;
